import { useQuery } from "react-query";
import { getAllUser } from "../../../../../actions/Utilities/ModuleManagement";

export const useGetUsers = () => {
    return useQuery("AllUser", getAllUser, {
        refetchOnWindowFocus: false,        
      });
}       